module.exports = __webpack_public_path__ + "img/6_newModelWorker_jh.f2cd8a60.png";